const YEAR_ONLY_REGEX = /^\d{4}$/;

export const expandYearOnlyInput = (value: string, dateFormat: string): string | null => {
    if (!YEAR_ONLY_REGEX.test(value)) {
        return null;
    }

    if (!dateFormat.includes('yyyy')) {
        return null;
    }

    // Keep pure year formats unchanged (for example: yyyy).
    if (!/[dD]/.test(dateFormat) || !/M/.test(dateFormat)) {
        return null;
    }

    // Skip text-based formats where month/day are words (for example: dd-MMM-yyyy).
    if (/(M{3,}|E{3,}|Q{3,})/.test(dateFormat)) {
        return null;
    }

    // Replace all date and time tokens with Jan 1 midnight defaults.
    return dateFormat.replace(/yyyy|MM|M|dd|d|HH|H|hh|h|mm|m|ss|s|aa|a/g, token => {
        switch (token) {
            case 'yyyy': return value;
            case 'MM': return '01';
            case 'M': return '1';
            case 'dd': return '01';
            case 'd': return '1';
            case 'HH': return '00';
            case 'H': return '0';
            case 'hh': return '12'; // 12:00 AM = midnight in 12-hour format
            case 'h': return '12';
            case 'mm': return '00';
            case 'm': return '0';
            case 'ss': return '00';
            case 's': return '0';
            case 'aa': return 'AM';
            case 'a': return 'AM';
            default: return token;
        }
    });
};
